/* Movatic WMS — Frontend | CesarFilho 932048016 */
import { createContext, useCallback, useContext, useState } from 'react'

type Toast = { id: number, type: 'success'|'error'|'info', message: string }
type Ctx = { show: (t: Omit<Toast, 'id'>) => void }

const ToastCtx = createContext<Ctx | null>(null)

export function useToast() {
  const ctx = useContext(ToastCtx)
  if (!ctx) throw new Error('ToastProvider ausente')
  return ctx
}

export function ToastProvider({ children }: { children: React.ReactNode }) {
  const [list, setList] = useState<Toast[]>([])
  const show = useCallback((t: Omit<Toast, 'id'>) => {
    const id = Date.now() + Math.random()
    const toast = { id, ...t }
    setList(prev => [...prev, toast])
    setTimeout(() => setList(prev => prev.filter(x => x.id !== id)), 3500)
  }, [])

  return (
    <ToastCtx.Provider value={{ show }}>
      {children}
      <div className="fixed top-4 right-4 z-50 flex flex-col gap-2">
        {list.map(t => (
          <div key={t.id} className={
            'px-3 py-2 rounded-xl shadow-card text-sm ' +
            (t.type==='success' ? 'bg-green-600 text-white' :
             t.type==='error' ? 'bg-red-600 text-white' : 'bg-neutral-800 text-white')
          }>
            {t.message}
          </div>
        ))}
      </div>
    </ToastCtx.Provider>
  )
}
